import baseRoute from '../baseRoute';

export default `${baseRoute}/company` as const;
